import { render, staticRenderFns } from "./AccessoryLegalNotices.vue?vue&type=template&id=f34d18f4"
import script from "./AccessoryLegalNotices.vue?vue&type=script&lang=js"
export * from "./AccessoryLegalNotices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports